export class DataCatalogRowLiteral {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "stringValue",
            "baseName": "stringValue",
            "type": "string",
            "format": ""
        },
        {
            "name": "intValue",
            "baseName": "intValue",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "doubleValue",
            "baseName": "doubleValue",
            "type": "number",
            "format": "double"
        },
        {
            "name": "boolValue",
            "baseName": "boolValue",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "nullValue",
            "baseName": "nullValue",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogRowLiteral.attributeTypeMap;
    }
    constructor() {
    }
}
